<template>
    <div class="ratio">
        <div class="row justify-center items-center image zoom cursor-pointer">
            <img v-lazy="img.url" :key="img.url"
                 :style="{'object-position': img.focalPoint ? img.focalPoint : false}">
            <div v-if="isVideo" class="has-video"></div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'VImg',

        props: {
            img: {
                type: Object,
                required: true,
            },
            isVideo: Boolean,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/front/Image.vue